<script>
import { mapGetters } from 'vuex';
import { library } from "@common/library/library";
import { componentStore } from "@common/componentStore/componentStore";
import { actionStore } from "@common/actionStore";

let layoutListConfig = {
    cId: "layoutList",
    cType: "layoutList",
    cTitle: "Layout List",
    cTemplate: `<div class="layout-list">
                    <control name="NEW_LAYOUT"></control>
                    <condensed-filter :prop-filter-options="filterOptions" cId="condensedFilter__layouts" :prop-filter-items="layoutListItems"  :prop-filtering="filtering" @update:prop-filtering="filtering = $event" :component-store-id="storeId"></condensed-filter>
                    <div class="list-container">
                        <div v-show="filtering" class="filtering-message">updating list</div>
                        <control v-show="!filtering"  name="LAYOUT_LIST" :items="filteredItems"></control>
                    </div>
                    <control name="SHOW_TEMPLATE"></control>
                    <div class="list-container" v-if="showTemplateList">
                        <control name="TEMPLATE_LIST"></control>
                    </div>
                </div>`,
    controls: [
        {
            name: 'NEW_LAYOUT',
            type: "button",
            label: "New Layout",
            onclick: "newLayout",
            cssClass: "e-block e-info",
        },
        {
            name: 'SHOW_TEMPLATE',
            type: "button",
            label: "Templates",
            onclick: "setShowTemplateList",
            cssClass: "e-block e-info template-list-button",
        },
        {
            name: 'LAYOUT_LIST',
            type: 'list',
            itemsSort: {
                sortBy: ['cTitle'],
            },
            labelSettings: {
                label: 'Layouts',
                helpText: 'These are existing configured layouts.  Layouts contain a template, datamap, and many other settings',
            },
            itemContentTemplate: `<div class="sub-list-item-container layout-list-item" :class="{'selected-item':component.selectedComponentId===data.cId}" :id="'layoutList-layout-id-' + data.interfaceId" @mouseenter="onMouseenter" @mouseleave="onMouseleave">
                               <div class="layout-header">
                                    <div class="layout-item" @click="component.selectLayout(data)">
                                        <span class="layout-title" :title="data.cTitle">{{data.cTitle}} <span v-if="data.isNew" class="component-status-flag">NEW</span> <span v-if="data.unsaved" class="component-status-flag">UNSAVED SETTINGS</span></span>
                                        <div class="component-list-more-details">
                                            <span class="layout-id">
                                                <span @click.stop="component.copyId(data.cId)">
                                                    <span v-show="component.copiedId === data.cId">ID Copied!</span>
                                                    <span v-show="component.copiedId !== data.cId">#{{data.cId}}</span>
                                                </span>
                                            </span>
                                            <span class="detail-indicator config-lock" :title="data.lockedConfig ? 'Locked Config' : 'Unlocked Config'">
                                                <span v-if="data.lockedConfig">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-lock" viewBox="0 0 16 16">
                                                        <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/>
                                                    </svg>
                                                </span>
                                                <span v-else>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-unlock" viewBox="0 0 16 16">
                                                        <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1H3z"/>
                                                    </svg>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="layout-action-button" v-if="hovered">
                                    <control name="LAYOUT_ACTIONS" :items="data.items"></control>
                                </div>
                          </div>`
        },
        {
            name: 'TEMPLATE_LIST',
            type: 'list',
            onclick: 'selectTemplate',
            itemsSource: 'configStore.getTemplateList()',
            itemsSort: {
                sortBy: 'name',
                // direction: 'desc'
            },
            labelSettings: {
                label: 'Layout Templates',
                helpText: 'These are the top level templates that can be used in a layout to determine it\'s overall structure.',
            },
            itemContentTemplate: `<div class="sub-list-item-container layout-list-item">
                               <div class="layout-header">
                                    <div class="layout-item">
                                        {{data.name}}
                                    </div>
                                </div>
                          </div>`
        },
        {
            name: 'LAYOUT_ACTIONS',
            initOnRender: true,
            type: 'dropdownbutton',
            onselect: 'layoutActions',
            cssClass: 'e-block preview-link'
        },
    ],
    layoutDatamap: [
        {
            "property": "selectedComponentId", "from": "layoutList", "to": "thisStore", "as": "selectedComponentId"
        }, {
            "property": "selectedTemplateId", "from": "layoutList", "to": "thisStore", "as": "selectedTemplateId"
        }, {
            "property": "layoutListPreviewType", "from": "layoutList", "to": "thisStore", "as": "layoutListPreviewType"
        }
    ]
};

let layoutListCmp = {
    name: 'layoutList',
    data() {
        return {
            // layoutList: false,
            selectedComponent: false,
            selectedComponentId: false,
            selectedTemplateId: false,
            layoutListPreviewType: 'layout',
            filteredItems: {},
            filtering: false,
            showTemplateList: false,
            copiedId: false
        };
    },
    watch: {
        filtering() {
            this.setScrollPosition();
        }
    },
    computed: {
        filterOptions() {
            return {
                cId: { label: 'Layout Id' },
                cTitle: { label: 'Layout Title' }
            };
        },
        layoutListItems() {
            let components = library.cloneObj(componentStore.getComponents());
            if (typeof components !== 'object') return [];
            for (let cId in components) {
                if (cId === 'length') continue;
                let comp = components[cId];
                if (comp.cType !== 'layoutContainer' || cId.indexOf('__') !== -1 || components[cId].showInCmpList === false) {
                    delete components[cId];
                    continue;
                }
                let items = [
                    { text: 'Copy Layout', value: 'copy' },
                    { text: 'Delete Layout', value: 'delete' },
                    { text: 'Export to File', value: 'export' },
                    { text: 'Import from File', value: 'import' }
                ];
                if (typeof IS_DEVDASH_QA !== 'undefined') {
                    if (IS_DEVDASH_QA) {
                        items.push({ text: 'Copy to DevDash', value: 'copyToDevDash' });
                    } else {
                        items.push({ text: 'Copy to DevDashQA', value: 'copyToDevDashQA' });
                    }
                }
                for (let i in items) {
                    if (i === 'length') continue;
                    items[i].cId = cId;
                }
                components[cId].items = Object.values(items);
                components[cId].interfaceId = cId.replace(/[\W]+/g, "-");
            }
            return library.sortObject(Object.values(components), ['cTitle']);
        },
        ...mapGetters({
            components: 'componentStore/getComponentOptions'
        })
    },
    methods: {
        layoutActions(extraCommand) {
            if (extraCommand.item && extraCommand.item.cId && extraCommand.item.value) {
                switch (extraCommand.item.value) {
                    case 'copy':
                        this.copyComponent(extraCommand.item);
                        break;
                    case 'delete':
                        this.deleteLayout(extraCommand.item.cId);
                        break;
                    case 'export':
                        this.exportComponent(extraCommand.item.cId);
                        break;
                    case 'import':
                        this.importComponent(extraCommand.item.cId);
                        break;
                    case 'copyToDevDash':
                        this.copyToDevDash(extraCommand.item.cId);
                        break;
                    case 'copyToDevDashQA':
                        this.copyToDevDashQA(extraCommand.item.cId);
                        break;
                    default:
                        break;
                }
            }
        },
        copyId(text) {
            this.copiedId = text;
            library.copyTextToClipboard(text);
            setTimeout(() => {
                this.copiedId = false;
            }, 2000); // NOSONAR
        },
        async newLayout() {
            let passedParams = { cType: 'layoutContainer' };
            let cId = await actionStore.createComponent(passedParams, { controlLabelType: 'layout' }, { dialogTitle: 'New Layout', submitButtonLabel: 'Create Layout' });
            let layout = this.layoutListItems.find((comp) => comp.cId === cId);
            if (layout) {
                this.selectLayout(layout);
            }
        },
        async copyComponent(item) {
            let passedParams = {
                componentToCopy: item.cId,
                createFromCopy: true,
                cType: 'layoutContainer'
            };
            let cId = await actionStore.createComponent(passedParams, { controlLabelType: 'layout' }, { dialogTitle: 'Copy Layout', submitButtonLabel: 'Copy Layout' });
            // await componentStore.getList(true, true);
            // await this.initComponents();
            let layout = this.layoutListItems.find((comp) => comp.cId === cId);
            if (layout) {
                this.selectLayout(layout);
            }
        },
        exportComponent(cId) {
            componentStore.exportComponent(cId);
        },
        async importComponent(cId) {
            let result = await componentStore.importComponent(cId);
            if (result.funcOnSuccess) {
                library.showLoadingIndicator('devDash');
                let cIdRes = result.funcOnSuccess;
                await componentStore.getList(true, true);
                let layout = this.layoutListItems.find((comp) => comp.cId === cIdRes);
                if (layout) {
                    this.selectLayout(layout);
                }
                library.hideLoadingIndicator('devDash');
            }
        },
        async copyToDevDash(cId) {
            let iConfig = await componentStore.getConfig(cId);
            await componentStore.createComponent(iConfig, 'devDash');
        },
        async copyToDevDashQA(cId) {
            let iConfig = await componentStore.getConfig(cId);
            await componentStore.createComponent(iConfig, 'devDashQA');
        },
        async deleteLayout(cId) {
            let iConfig = await componentStore.getConfig(cId);
            if (iConfig.lockedConfig) {
                library.showDialog('You cannot delete this component because it is locked.', false, false, { showAsAlert: true });
                return false;
            }
            library.showDialog("Are you sure you want to delete this component?",
                async () => {
                    const deleted = await componentStore.deleteComponent(cId);
                    if (deleted) {
                        if (this.selectedComponentId && this.selectedComponentId === cId) {
                            this.selectLayout(false);
                        }
                        componentStore.getList(true, true);
                    }
                },
                false,
                {
                    title: "Confirm to Continue"
                });
            return true;
        },
        async onLoad() {
            await componentStore.getList(true);
        },
        setScrollPosition() {
            let scrollToPosition = (elemId, toTop) => {
                setTimeout(() => {
                    let iElem = document.getElementById(elemId);
                    if (iElem) {
                        if (toTop) iElem.scrollTo({ top: 0, behavior: 'smooth' });
                        else {
                            iElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                            iElem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }
                }, 2000); // NOSONAR
            };
            if (!this.selectedComponent) {
                scrollToPosition('LAYOUT_LIST_layoutList_container', true);
                return;
            }
            let component = this.selectedComponent;
            let elem = document.getElementById('layoutList-layout-id-' + component.interfaceId);
            if (elem) {
                scrollToPosition('layoutList-layout-id-' + component.interfaceId);
            }
            else {
                this.selectedComponent = false;
                this.selectedComponentId = false;
                scrollToPosition('LAYOUT_LIST_layoutList_container', true);
            }
        },
        selectLayout(layout) {
            this.selectedComponent = false;
            this.selectedComponentId = false;
            this.selectedComponent = layout;
            this.selectedComponentId = layout.cId;
            this.layoutListPreviewType = "layout";
            if (layout) this.setScrollPosition();
        },
        selectTemplate(template) {
            this.selectedTemplateId = false;
            this.$nextTick(() => {
                this.selectedTemplateId = template.id;
            });
            this.layoutListPreviewType = "template";
        },
        setShowTemplateList() {
            this.showTemplateList = !this.showTemplateList;
        }
    }
};

componentStore.initComponent(layoutListCmp, layoutListConfig);
export { layoutListCmp, layoutListConfig };
export default layoutListCmp;
</script>

<style>
    #LAYOUT_LIST_layoutList_container{
        max-height: 500px;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 2px;
        /* margin-bottom: 10px; */
    }
</style>
<style scoped>
    /*.list-container {*/
    /*    max-height: 500px;*/
    /*    overflow-y: auto;*/
    /*    overflow-x: hidden;*/
    /*    margin-bottom: 10px;*/
    /*}*/
    :deep(.layout-header) {
        min-width: 100px;
        max-width: 100%;
        width: 100%;
    }
    :deep(.layout-item) {
        background: #eee;
        flex-grow: 9;
        padding: 6px 8px;
        overflow: hidden;
        font-weight: bold;
        cursor: pointer;
    }
    :deep(.layout-item:hover)  {
        background: #f3d9dd;
    }
    :deep(.layout-title) {
        display: block;
        font-size: 15px;
        margin-bottom: 3px;
        white-space: nowrap;
    }
    :deep(.layout-id) {
        display: inline-block;
        font-size: 14px;
        color: #555;
        white-space: nowrap;
        border: 2px dashed white;
        border-radius: 8px;
        padding: 1px 3px
    }
    :deep(.layout-id:hover) {
        background: white;
    }
    :deep(.sub-list-item-container){
        display: flex;
        margin-bottom: 2px;
    }
    :deep(.sub-list-item-container.selected-item .layout-item) {
        background: pink;
    }
    :deep(.label-wrapper .label-text) {
        font-size: 15px !important;
    }
    :deep([cid="condensedFilter__layouts"]) {
        margin-top: 15px;
    }
    :deep(.layout-action-button .e-control), :deep(.layout-action-button .control), :deep(.layout-action-button .control) {
        height: 100%;
    }
    :deep(.layout-action-button .e-control .e-icon-right) {
        margin-right: 0;
    }
    :deep(.template-list-button) {
        margin-bottom: 10px;
    }
</style>
